import { useEffect, useRef } from "react";
import { useToast } from "../context/ToasterContext";
import { iApiError, iApiSuccess } from "../types/commonTypes";

interface UseApiToastParams {
	apiError: iApiError | null;
	apiSuccess: iApiSuccess | null;
	onClose: () => void;
}

/**
 * Custom hook to display toast notifications for API errors and success messages
 * @param apiError - API error object with statusCode and message
 * @param apiSuccess - API success object with statusCode and message
 * @param onClose - Callback function to execute when toast closes
 */
export const useApiToast = ({ apiError, apiSuccess, onClose }: UseApiToastParams) => {
	const { showToast } = useToast();
	const onCloseRef = useRef(onClose);

	useEffect(() => {
		onCloseRef.current = onClose;
	});

	useEffect(() => {
		if (apiError) {
			showToast(apiError.message, () => onCloseRef.current(), "error");
		}
		if (apiSuccess) {
			showToast(apiSuccess.message, () => onCloseRef.current(), "success");
		}
	}, [apiError, apiSuccess, showToast]);
};

